import { useState } from 'react';

export default function useUser() {
  const getToken = () => {
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken?.user
  };

  const [user, setUser] = useState(getToken());

  return {
    setUser: null,
    user
  }
}